export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              tagname: 'div',
              name: "Colunas Formulário",
              attributes: { class: 'row-cubo' },
              components: [
                {
                  type: 'columnImageForm1',
                },
                {
                  type: 'columnForm1',
                },
      
              ],
              styles: `
             .row-cubo{
                display: flex; 
                flex-direction:row; 
                width:100%; 
             }
             @media (max-width:992px){
              .row-cubo{
                flex-direction:column;
              }
             }
            `,
            },
          },
          view: {
      
          },
};
  return component; 
};